import produce from 'immer';

import {
	OPEN_MODAL_FULFILLED,
	CLOSE_MODALS_FULFILLED
} from '../constants/modals.actions';
import { FETCH_PAGE_FULFILLED } from '../constants/page.actions';

const modalReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case (OPEN_MODAL_FULFILLED): {
				draft.active = action.payload.modal;
				break;
			}
			case (CLOSE_MODALS_FULFILLED): {
				draft.active = '';
				break;
			}
			case (FETCH_PAGE_FULFILLED): {
				draft.active = '';
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		active: ''
	}
);

export default modalReducer;
